<template>
  <div class="helper">
    <font-awesome-icon
      class="helper__icon"
      icon="info-circle"
    />
    <div class="helper__text">
      <p
        v-for="(line, index) in textLines"
        :key="index"
        class="helper__paragraph"
      >
        {{ line }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TgFormHelperText',

  props: {
    infoText: {
      type: String,
      required: true,
    },
  },

  computed: {
    textLines () {
      return this.infoText.split('\n');
    },
  },
};
</script>

<style>

</style>
